/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeLogic/ChallengeAuthorities/SolveGameDailyKlondikeAuthority',[
    'SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority'
    ],
    function (IDailyKlondikeAuthority) {
    "use strict";

    var SolveGameDailyKlondikeAuthority = function (param) {
        this.initSolveGameDailyKlondikeAuthority(param);
    };

    SolveGameDailyKlondikeAuthority.constructor = SolveGameDailyKlondikeAuthority;
    SolveGameDailyKlondikeAuthority.prototype = Object.create(IDailyKlondikeAuthority.prototype);

    SolveGameDailyKlondikeAuthority.prototype.initSolveGameDailyKlondikeAuthority = function () {
        IDailyKlondikeAuthority.call(this);
    };

    return SolveGameDailyKlondikeAuthority;
});
